// register-creditor
import SideMenu from '@/containers/side-menu/SideMenu.vue';
import Creditors from '@/pages/creditors/Creditors.vue';

export default {
  path: '/register-creditor',
  name: 'Creditors',
  components: {
    mainContent: Creditors,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'register-creditor',
    },
    breadcrumb: {
      title: 'Contas',
      paths: [{ title: 'Credores' }],
    },
  },
};
